import { Modal } from './Modal';
import { Avatar, getCat, fmt } from '../lib/helpers';

export function ExpenseDetailModal({ expense, people, groups, onDelete, onClose }) {
  const personById = (id) => people.find(p => p.id === id);
  const group = groups.find(g => g.id === expense.group_id);
  const payer = personById(expense.paid_by);
  const cat = getCat(expense.category);

  const handleDelete = async () => {
    if (!window.confirm('Delete this expense?')) return;
    await onDelete(expense.id);
    onClose();
  };

  return (
    <Modal title={expense.name} onClose={onClose}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1rem' }}>
        <div style={{
          width: 48, height: 48, borderRadius: 12, fontSize: 22,
          background: group ? group.color + '22' : '#eee',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          {cat.icon}
        </div>
        <div>
          <div style={{ fontSize: 26, fontWeight: 700 }}>{fmt(expense.amount)}</div>
          <div style={{ fontSize: 12, color: 'var(--text-faint)' }}>
            {payer?.name} paid · {expense.date} · {group?.name}
          </div>
        </div>
      </div>

      <div className="section-label" style={{ marginBottom: '0.5rem' }}>Split among</div>
      <div style={{ marginBottom: '1.25rem' }}>
        {expense.split.map(({ person_id, share }) => {
          const p = personById(person_id);
          if (!p) return null;
          return (
            <div className="member-split" key={person_id}>
              <div className="member-split-left">
                <Avatar person={p} />
                <span>{p.name}</span>
              </div>
              <span style={{ fontWeight: 500 }}>{fmt(share)}</span>
            </div>
          );
        })}
      </div>

      <button className="btn btn-danger" style={{ width: '100%', justifyContent: 'center' }} onClick={handleDelete}>
        🗑 Delete expense
      </button>
    </Modal>
  );
}
